import react from "react";
import Request from "../../../../api/Requests";

const getEventList = (params, filter) => {
    params["filter"] = filter;
    return Request('events/list', 'GET', params, true);
}

export default {
    getEventList,
}